import module from '../module';

function OrderTabPaymentDetailsController($scope, groupOrderService) {

    $scope.configuration.singlePayOrder = groupOrderService.getSinglePayOrder() || {};

    $scope.acceptPaymentDetails = function (form) {

        if (!form.$valid) {
            form.highlightAllErrors();
            return;
        }

        $scope.next();
    };
}

module.controller('OrderTabPaymentDetails', ['$scope', 'GroupOrder', OrderTabPaymentDetailsController]);




// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderTabPaymentDetailsController.js